import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslations from './translations/en.json';
import jaTranslations from './translations/ja.json';
import zhTranslations from './translations/zh.json'
import zhoTranslations from './translations/zho.json'
import frTranslations from './translations/fr.json';
import deTranslations from './translations/de.json';
import koTranslations from './translations/ko.json';
import esTranslations from './translations/es.json';

export const langOptions = [
    { label: "English", value: "en" }, 
    { label: "Deutsch", value: "de" }, 
    { label: "Español", value: "es" }, 
    { label: "Français", value: "fr" }, 
    { label: "日本語", value: "ja" }, 
    { label: "简体中文", value: "zh" }, 
    { label: "繁體中文", value: "zho" },
    { label: "한국어", value: "ko" }, 
];

const resources = {
    en: { translation: enTranslations },
    ja: { translation: jaTranslations },
    zh: { translation: zhTranslations },
    zho: { translation: zhoTranslations },
    fr: { translation: frTranslations },
    de: { translation: deTranslations },
    ko: { translation: koTranslations },
    es: { translation: esTranslations },
};

export const getInitialLanguage = () => {
    let userLanguage = navigator.language;
    if(userLanguage === "zh-TW"){ userLanguage = 'zho'}
    const supportedLanguages = ['en', 'ja', 'zho', 'zh', 'fr', 'de', 'ko', 'es'];
    let languageCode ='';

    if(userLanguage === 'zho'){
        languageCode = 'zho';
    }else{
        languageCode = userLanguage.substring(0, 2).toLowerCase();
    }
  
    return supportedLanguages.includes(languageCode) ? languageCode : 'en'; // Default to English
  };
  
const initialLanguage = getInitialLanguage();

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        detection: {
          order: ['querystring'],
          lookupQuerystring: "lang",
          caches: []
        },
        fallbackLng: initialLanguage,
        interpolation: {
            escapeValue: false
        }
    });


export default i18n;
